export { REVISION_CATEGORY } from 'shared/components/organisms/ModuleReviewFormModal/config';
import ModuleReviewFormModal from 'shared/components/organisms/ModuleReviewFormModal/ModuleReviewFormModal';

export default ModuleReviewFormModal;
